import { Logs } from "../shared";
import gsap from '@gsap/business';
import { ScrollTrigger } from '@gsap/business/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class Filters {

  constructor(node, instance) {
    this.node = node;
    this.instance = instance
    this.transition = false;
    this.loaded = false;
  }

  init() {
    this.addListeners();
    this.loaded = true;
  }

  restart(context) {
    this.currentContext = context;
    if (this.hasFilters(context)) {
      this.transition = true;
      this.currentContext.style.opacity = 0;
      setTimeout((x) => {
        this.instance.init();
        Logs.debug( `Restarting Filters`);
      }, 300);
    }
  }

  hasFilters(context) {
    return context.querySelector('.facetwp-facet') ? true : false;
  }

  addListeners() {
    this.refreshHandler = this.onFiltersRefresh.bind(this);
    this.updatedHandler = this.onFiltersUpdated.bind(this);

    document.addEventListener('facetwp-refresh', this.refreshHandler);
    document.addEventListener('facetwp-loaded', this.updatedHandler);
  }

  onFiltersRefresh() {
    if ( window.FWP.soft_refresh == true ) {
      window.FWP.enable_scroll = true;
    } else {
      window.FWP.enable_scroll = false;
    }
    window.client.scroller.refresh();
    Logs.debug( `Filters Data REFRESH event`);
  }

  onFiltersUpdated() {
    if ( window.FWP.enable_scroll == true ) {
      window.scrollTo(0, 0);
    }
    if (this.transition) {
      gsap.to(this.currentContext, {
        opacity: 1
      });
      this.transition = false;
    }
    window.client.scroller.refresh();
    Logs.debug( `Filters Data UPDATED event`);
  }

  removeListeners() {
    document.removeEventListener('facetwp-refresh', this.refreshHandler);
    document.removeEventListener('facetwp-loaded', this.updatedHandler);
  }
}
